import api from "../api/axiosInstance";

// Send contact form
export const sendContact = async (formData) => {
  try {
    const response = await api.post("/contact/create", formData); 
    return response.data;
  } catch (error) {
    console.error("Error sending contact form:", error);
    throw error;
  }
};